import {
  anEntityCriticalityConfig,
  anEntityCriticalityConfigPage,
  EntityCriticalityConfig,
  mockEntityCriticalityConfigsListQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const getEntityCriticalityConfigsListQuery_create = (
  newConfig: Partial<EntityCriticalityConfig>
) =>
  mockEntityCriticalityConfigsListQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      const configs = anEntityCriticalityConfigPage().objects;

      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entityCriticalityConfigs: anEntityCriticalityConfigPage({
            objects: [
              ...configs,
              anEntityCriticalityConfig({
                id: '0',
                entityCount: 0,
                ...newConfig,
              }),
            ],
            total: 10,
          }),
        },
      });
    }
  );

export const handlers = [
  mockEntityCriticalityConfigsListQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entityCriticalityConfigs: anEntityCriticalityConfigPage({
            total: 10,
          }),
        },
      });
    }
  ),
];
